//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Anchor from '@components/atoms/anchor/Anchor';
import { BodyText } from '@components/atoms/text/Text';
import supportImage from '@images/support.svg';
import { OnboardingButtonAnchor } from '@welcome-page/components/onboarding/buttons/OnboardingButtonAnchor';
import { OnboardingInfoCard } from '@welcome-page/components/onboarding/info/OnboardingInfoCard';
import { ONBOARDING_TRACKING_ID } from '@welcome-page/constants/OnboardingConstants';

import { BAZAARVOICE_CONTACT_SUPPORT_URL } from 'app/constants/support-links';

export const OnboardingSupportCard = () => {
  return (
    <StyledInfoCard
      title='Support'
      icon={<img src={supportImage} width={73} height={74} alt='' />}
    >
      <BodyText>
        If you’re running into issues, visit our&nbsp;
        <ResourceAnchor
          trackingId={ONBOARDING_TRACKING_ID.SUPPORT_KNOWLEDGE_BASE_ANCHOR}
          href='https://docs.bazaarvoice.com/articles/vibe/vibe'
        >
          Knowledge Base
        </ResourceAnchor>{' '}
        for in-depth help resources. For further assistance, contact Bazaarvoice
        Support.
      </BodyText>
      <OnboardingButtonAnchor
        trackingId={ONBOARDING_TRACKING_ID.SUPPORT_CONTACT_SUPPORT_BUTTON}
        href={BAZAARVOICE_CONTACT_SUPPORT_URL}
        target='_'
      >
        Contact Support
      </OnboardingButtonAnchor>
    </StyledInfoCard>
  );
};

const StyledInfoCard = styled(OnboardingInfoCard)`
  gap: 12px;
`;

const ResourceAnchor = styled(Anchor).attrs({ target: '_blank' })(
  ({ theme }) => `
  &&, &&:hover {
    color: ${theme.colors.teal2};
  }
`,
);
